import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EditionEnrolledUser } from "../types";

interface UseEditionEnrolledUsersArgs {
  corporateId: string | number;
  editionId: string | number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useEditionEnrolledUsers = ({
  corporateId,
  editionId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseEditionEnrolledUsersArgs): PaginatedListResult<EditionEnrolledUser> => {
  const url =
    corporateId && editionId
      ? `${ServicesURL.getEnrollEditionDetail}?corporateId=${corporateId}&editionId=${editionId}&showIssuedCertificate=true`
      : null;

  return usePaginatedList<EditionEnrolledUser>(
    url,
    { page, pageSize, search, fieldFilters },
    {
      responseKey: "users",
      totalElementsKey: "totalElements",
      totalPagesKey: "totalPages",
    },
  );
};

export const getEditionUserName = (u: EditionEnrolledUser): string => {
  const full = [u.userFirstName, u.userLastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return full || u.email || "-";
};

export const getEditionUserId = (u: EditionEnrolledUser): string | number =>
  u.idUser ?? "";
